import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import * as _ from 'lodash';
import classnames from 'classnames';
import $i18n from '@alife/panda-i18n';
import { CnButton, CnMessage, CnDialog, CnBalloon } from '@alife/cn-ui';
import { CnPrint, doLog } from '../cn-print';
import { getUUID, callWindVane, isAndroid, deliveryTasksCallback, formatData, getSelectedRecords, handleSelectedKeys, transformBatchTaskInfo, transformTaskInfo, getProdHostName, } from 'src/utils';
import SelectPrintDialog from './select-printer';
import './index.scss';
const defaultButtonConfig = {};
let cnPrintInstance;
let mixPrintInstance;
let key2Request;
let getPrinterFlag = false; // 获取打印配置列表标志
let printerList = []; // 打印机列表
const CnPrintBtn = (props) => {
    const { children, queryParams: propsQueryParams, queryParamCheck, selectedRowKeys: propsSelectedRowKeys, selectedRowRecords: propsSelectedRecord, config: oldConfig, configJsx, csrfUrl = '/api/csrf', onSuccess, btnProps = {}, requestBeforePrint, requestBeforePrint4L2, isMenuItem = false, _bindFilterData, tableRef, progressParams: propsProgressParams, disabled: buttonDisabled = false, buttonConfig = defaultButtonConfig, 
    /** effect 监听_state 会导致死循环 */
    _state = {}, formatResponse, } = props;
    const config = useMemo(() => {
        return configJsx?.() || oldConfig || {};
    }, [configJsx, oldConfig]);
    const { isFetchConfig = true, isMixPrint = true, isReloadTable = true, progressParams: configProgressParams, enableRule, getIsEnable, } = config;
    const { className } = btnProps;
    const queryParams = useMemo(() => {
        return propsQueryParams || _bindFilterData || {};
    }, [propsQueryParams, _bindFilterData]);
    const progressParams = useMemo(() => {
        return propsProgressParams || configProgressParams || {};
    }, [propsProgressParams, configProgressParams]);
    const csrfIdRetryCount = useRef(0);
    const [selectedRecords, setSelectedRecords] = useState([]);
    const selectedRecordsRef = useRef(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const selectedRowKeysRef = useRef(null);
    const [csrfId, setCsrfId] = useState('');
    const [disabled, setDisabled] = useState(false);
    const [name, setName] = useState('');
    const currentPrintRef = useRef();
    const [needConfig, setNeedConfig] = useState(false);
    const needConfigRef = useRef(null);
    const [selectPrintVisible, setSelectPrintVisible] = useState(false);
    const [hoverInfo, setHoverInfo] = useState({});
    const csrfRef = useRef(null);
    useEffect(() => {
        csrfRef.current = csrfId;
    }, [csrfId]);
    useEffect(() => {
        setSelectedRecords(propsSelectedRecord);
    }, [propsSelectedRecord]);
    useEffect(() => {
        selectedRecordsRef.current = selectedRecords;
        if (!selectedRecordsRef.current?.length) {
            setDisabled(true);
        }
        else if (getIsEnable) {
            setDisabled(getIsEnable(selectedRecordsRef.current));
        }
        else if (typeof enableRule !== 'undefined') {
            setDisabled(!!enableRule);
        }
        else if (typeof buttonDisabled !== 'undefined') {
            setDisabled(buttonDisabled);
        }
    }, [selectedRecords, getIsEnable, enableRule, buttonDisabled]);
    useEffect(() => {
        const tempHoverInfo = { ...hoverInfo };
        const tempContent = buttonConfig?.buttonHoverInfo?.hoverInfo?.content || '';
        const tempTitle = buttonConfig?.buttonHoverInfo?.hoverInfo?.title || '';
        if (tempContent) {
            if (typeof tempContent === 'function') {
                tempHoverInfo.content = tempContent(null, _state);
            }
            else if (tempContent.group === '__dataSource__') {
                tempHoverInfo.content = _state[tempContent.param][tempContent.secondParam];
            }
            else {
                tempHoverInfo.content = tempContent;
            }
        }
        if (tempTitle) {
            if (typeof tempTitle === 'function') {
                tempHoverInfo.title = tempTitle(null, _state);
            }
            else if (tempTitle.group === '__dataSource__') {
                tempHoverInfo.title = _state[tempTitle.param][tempTitle.secondParam];
            }
            else {
                tempHoverInfo.title = tempTitle;
            }
        }
        setHoverInfo(tempHoverInfo);
    }, [buttonConfig]);
    useEffect(() => {
        setSelectedRowKeys(propsSelectedRowKeys);
    }, [propsSelectedRowKeys]);
    useEffect(() => {
        selectedRowKeysRef.current = selectedRowKeys;
    }, [selectedRowKeys]);
    useEffect(() => {
        needConfigRef.current = needConfig;
    }, [needConfig]);
    const printInstance = useMemo(() => {
        if (!cnPrintInstance) {
            cnPrintInstance = new CnPrint();
            cnPrintInstance.config = {};
        }
        if (isMixPrint) {
            if (mixPrintInstance) {
                return mixPrintInstance;
            }
            mixPrintInstance = new CnPrint({
                isNeedWetPrint: true,
                isNeedCloudPrint: false,
                isNeedPddPrint: true,
                isNeedJdPrint: true,
                isNeedBytePrint: true,
                isNeedKuaiShouPrint: true,
                isNeedVipPrint: true,
                isNeedHuaWeiPrint: true, // 是否华为商城打印
            });
            mixPrintInstance.config = {};
            return mixPrintInstance;
        }
        return cnPrintInstance;
    }, [isMixPrint]);
    const fetchConfig = useCallback(() => {
        if (!key2Request) {
            key2Request = fetch(`${getProdHostName()}/api/print/wmiconfig/PrinterSelectAndEncoding/key2`, {
                method: 'post',
                mode: 'cors',
                credentials: 'include',
            }).then((res) => res.json());
        }
        key2Request
            .then((data) => {
            setNeedConfig(data?.data);
        })
            .catch((e) => console.error(e));
    }, []);
    const initMessageCenter = useCallback(() => {
        // 获取客户端版本信息
        printInstance?.addEventListen?.('getVersion', (data) => {
            if (!getPrinterFlag && data.message === '成功') {
                printInstance?.getPrintConfigNameList?.();
                getPrinterFlag = true;
            }
        });
        // 获取打印配置列表
        printInstance?.addEventListen?.('getPrintConfigNameList', (result) => {
            const { data: { configList = [] }, } = result;
            const tmpPrinterList = [];
            configList.forEach((cell) => {
                tmpPrinterList.push({
                    label: cell.configName,
                    value: cell.configPrinterName,
                });
            });
            printerList = tmpPrinterList;
        });
    }, [printInstance]);
    const initWetPrint = useCallback(() => {
        if (isAndroid)
            return;
        if (printInstance) {
            printInstance.handlerError = function () {
                CnMessage.warning($i18n.get({
                    id: 'ThePrintControlIsAbnormalPlease_1471847901',
                    dm: '打印控件异常，请确认后刷新页面重试！',
                }));
            };
            printInstance.handlerClose = function () {
                CnMessage.warning($i18n.get({
                    id: 'ThePrintLinkIsBrokenPlease_35510703',
                    dm: '打印链接断开，请确认后刷新页面重试！',
                }));
            };
        }
        // 请求打印配置
        initMessageCenter();
        isFetchConfig && fetchConfig();
    }, [fetchConfig, initMessageCenter, printInstance, isFetchConfig]);
    const fetchCsrf = useCallback(() => {
        // 3次尝试获取csrfId
        if (csrfIdRetryCount.current > 2) {
            return;
        }
        csrfIdRetryCount.current += 1;
        fetch(csrfUrl)
            .then((res) => res.json())
            .then((data) => {
            if (!data?.data?.token) {
                fetchCsrf();
                return;
            }
            setCsrfId(data?.data?.token);
        })
            .catch((e) => console.error(e));
    }, [csrfUrl]);
    useEffect(() => {
        const { socketType = 'websocket', name: configName } = config || {};
        let printSocket = localStorage.getItem('printSocket');
        if (!printSocket) {
            localStorage.setItem('printSocket', socketType);
            printSocket = socketType;
        }
        if (window.iBirdHybirdApi) {
            window.iBirdHybirdApi.setMessageCallback('CallbackFunc', (__unuse, args) => {
                const res = JSON.parse(args[1]);
                const { module = '', toDo = '' } = res;
                if (module.toLowerCase() === 'print') {
                    if (toDo === 'sendTask') {
                        deliveryTasksCallback(res, config);
                    }
                }
            });
            if (printSocket !== 'hybridapi') {
                initWetPrint();
            }
        }
        else {
            initWetPrint();
            localStorage.setItem('selectedRowKeysStorage', '');
        }
        setName(configName || '');
        fetchCsrf();
    }, [printInstance, config, initWetPrint, fetchCsrf]);
    function handleError(res, task = {}) {
        const { extendTaskRemark = '[]' } = task;
        let parsedExtendTaskRemark;
        const remark = [];
        try {
            parsedExtendTaskRemark = JSON.parse(extendTaskRemark);
            parsedExtendTaskRemark.forEach((item) => {
                const { label = '', value = '' } = item;
                if (item.forEach) {
                    item.forEach((remarkItem) => {
                        const { label: tmpLabel, value: tmpValue } = remarkItem;
                        remark.push(`${tmpLabel}:${tmpValue}`);
                    });
                }
                else if (label && value) {
                    remark.push(`${label}:${value}`);
                }
            });
        }
        catch (e) {
            console.error(e);
        }
        let errorMsg = '';
        if (res.error && res.error.message) {
            errorMsg = res.error.message + (remark.length ? `[${remark.join(';')}]` : '');
        }
        else {
            const errorCode = typeof res.status !== 'undefined' ? res.status : '';
            const remarkDesc = remark.length ? `[${remark.join(';')}]` : '';
            errorMsg = $i18n.get({
                id: 'PrintRequestFailedPleaseCheckBefore_1804043096',
                dm: '打印请求失败，请核对后再打印或补打。[httpCode:{errorCode}]{remarkDesc}',
            }, { errorCode, remarkDesc });
        }
        if (errorMsg) {
            CnDialog.alert({
                title: errorMsg,
                size: 'small',
            });
        }
        // 接口调用异常埋点
        try {
            doLog?.({
                request: {
                    task: {
                        url: task.url || '',
                    },
                },
                status: 'failed',
                process: 'FRONT_END',
                action: 'recvPrintRequestResponse',
                pageUrl: window.location.href,
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    function fetchAndPrint(taskList) {
        const task = taskList[0];
        if (!task) {
            return;
        }
        const params = JSON.parse(task.params);
        let tps = new Date().getTime();
        let tmpParams = {
            data: params,
            csrfId: csrfRef.current,
            _csrf: csrfRef.current,
        };
        if (typeof progressParams === 'function') {
            tmpParams = progressParams(tmpParams, selectedRecordsRef.current);
        }
        const options = {
            method: 'post',
            body: JSON.stringify(tmpParams),
            credentials: 'include',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
            },
        };
        if (task.url.indexOf(window.location.hostname) === -1) {
            options.mode = 'cors';
        }
        fetch(task.url.replace('http:', ''), options)
            .then((res) => res.json())
            .then((res) => {
            let data = res?.data || {};
            const error = res?.error || res?.data?.error;
            if (error && error?.message) {
                handleError(res, task);
            }
            if (formatResponse) {
                data = formatResponse(data);
            }
            tps = new Date().getTime() - tps;
            if (data.standardData && data.standardData.length) {
                // 新版打印协议
                const { standardData = [] } = data || {};
                try {
                    doLog?.({
                        request: {
                            task: {
                                url: task.url,
                            },
                        },
                        status: 'success',
                        process: 'FRONT_END',
                        action: 'recvPrintRequestResponse',
                        pageUrl: window.location.href,
                        response: data,
                        timeCost: tps,
                        ...standardData[0],
                    });
                }
                catch (e) {
                    console.error(e);
                }
                standardData.forEach((item) => {
                    if (!item) {
                        return;
                    }
                    const { documents, ...rest } = item;
                    const { printer, configName } = rest;
                    const packagePrintData = {
                        printConfig: {
                            doPrintAlarm: false,
                            ...rest,
                        },
                        data: documents,
                    };
                    if (currentPrintRef?.current?.label) {
                        packagePrintData.printConfig.configName = currentPrintRef?.current?.label;
                        packagePrintData.printConfig.printer = currentPrintRef?.current?.value;
                    }
                    else if (!printer && configName) {
                        const currentItem = printerList.find((cell) => {
                            return cell.label == configName;
                        });
                        packagePrintData.printConfig.printer = currentItem ? currentItem.value : '';
                    }
                    if (isAndroid) {
                        const sendData = printInstance?.getPrintAgreement(packagePrintData);
                        packagePrintData.printConfig.dataSource === 'CAINIAO' &&
                            callWindVane('bird-module', 'print', sendData, (result) => {
                                console.log('[fetchPrint success]', result);
                            }, (e) => {
                                console.log('[fetchPrint error]', e);
                            });
                    }
                    else {
                        printInstance?.printData?.(packagePrintData);
                    }
                });
            }
            else {
                // 老打印模型
                // documents可能没有，因为有些单据状态不对，还不能正常打印（零售通），所以有两种情况
                if (data.documents) {
                    // 如果存在多种单据，需要取出configName，分组打印
                    const printArr = formatData(data);
                    printArr.forEach((item) => {
                        const { pdfPrint, configName: itemCOnfigName, bizTyp, bizType, docType, documents, } = item;
                        let sendData = {
                            printConfig: {
                                protocolCustom: true,
                                pdfPrint: pdfPrint || false,
                                printType: data.printType || 'cloud',
                                warehouseId: data.warehouseId || '',
                                responseTime: data.responseTime || '',
                                networkTime: tps,
                                bizIdentity: data.bizIdentity || '',
                                taskID: data.taskID || '',
                                traceId: data.traceId || '',
                                configName: currentPrintRef?.current?.label || itemCOnfigName,
                                bizTyp: bizTyp || '',
                                bizType: bizType || '',
                                docType: docType || '',
                                printNode: data.printNode || '',
                                accountNo: data.accountNo || '',
                                accountName: data.accountName || '',
                                printer: currentPrintRef?.current?.value || data.printer || '',
                            },
                            data: documents,
                        };
                        // 调用打印接口
                        if (isAndroid) {
                            sendData = {
                                data: {
                                    requestID: getUUID(),
                                    version: '1.0',
                                    cmd: 'print',
                                    task: { taskID: item.taskID, documents: item.documents },
                                    warehouseId: data.warehouseId || params.warehouseId || '',
                                    responseTime: data.responseTime || '',
                                    networkTime: tps,
                                    bizIdentity: data.bizIdentity || '',
                                    taskID: data.taskID || '',
                                    traceId: data.traceId || '',
                                },
                                businessType: 1,
                                messageType: 3,
                                configName: itemCOnfigName,
                            };
                            callWindVane('bird-module', 'print', sendData, (result) => {
                                console.log('[fetchPrint success]', result);
                            }, (e) => {
                                console.log('[fetchPrint error]', e);
                            });
                        }
                        else {
                            printInstance?.printData?.(sendData);
                        }
                    });
                    // 正常打印单据量埋点
                }
                if (data.pddData) {
                    const protocol = location.protocol !== 'https' ? 'ws://localhost:5000' : 'wss://localhost:18653';
                    const socket = new WebSocket(protocol);
                    socket.onopen = () => {
                        socket.send(JSON.stringify({
                            cmd: 'setPrinterConfig',
                            requestID: '123458976',
                            version: '1.0',
                            printer: {
                                name: $i18n.get({
                                    id: 'PDDSinglePrinter',
                                    dm: 'PDD面单打印机',
                                }),
                                PrintTopLogo: true,
                                PrintBottomLogo: false,
                                horizontalOffset: 2,
                                verticalOffset: 2,
                            },
                        }));
                        socket.send(JSON.stringify(data.pddData));
                        socket.close();
                    };
                }
            }
            taskList.shift();
            execPrint(taskList);
        }, (res) => {
            handleError(res, task);
            taskList.shift();
            execPrint(taskList);
        });
    }
    function execPrint(taskList) {
        if (!taskList?.[0]) {
            setDisabled(false);
            onSuccess?.();
            if (isReloadTable === true) {
                tableRef?.remoteInstance?.load?.();
                tableRef?.remoteInstance?.remoteOperation?.current?.innerInfo?.setSelectKeys?.([]);
            }
            deliveryTasksCallback({
                success: true,
            }, config);
            return;
        }
        setDisabled(false);
        const taskNum = taskList?.length || 0;
        CnMessage.notice($i18n.get({
            id: 'PrintRequestIsBeingSentDo_385032042',
            dm: '正在发送打印请求,请勿关闭或刷新页面,剩余任务数：{taskNum}',
        }, { taskNum }));
        fetchAndPrint(taskList);
    }
    const handlePrintSelected = useCallback(() => {
        const tmpSelectedRowKeys = selectedRowKeysRef.current || [];
        const tmpSelectedRecords = selectedRecordsRef.current || [];
        if (_.isEmpty(tmpSelectedRowKeys)) {
            CnMessage.warning($i18n.get({
                id: 'PleaseSelectAtLeastOneRecord_858803615',
                dm: '请至少选择一项记录',
            }));
            return;
        }
        if (window.location.host.includes('gwms-pick.cainiao.com') ||
            window.location.host.includes('gwms-pick.sg.cainiao.com')) {
            // 拣选单补打，添加最多选择20条的条件限制
            if (config.billType === 'pick_bill' &&
                config.printType === 'repeat' &&
                tmpSelectedRowKeys?.length > 20) {
                CnMessage.warning($i18n.get({
                    id: 'OnlyAMaximumOfRecords_715097890',
                    dm: '最多只能选择20条记录',
                }));
                return;
            }
        }
        CnMessage.notice($i18n.get({
            id: 'PrintingTaskIsBeingIssuedPlease_318727833',
            dm: '正在下发打印任务，请稍后！',
        }));
        const { isBatch = false, printType, socketType = 'websocket' } = config;
        console.log('config', config);
        const userInfo = (window.headerGlobalData?.getData('userInfo') || {});
        const warehouseId = `${(window?.headerGlobalData?.getData('warehouseId') || '')}`;
        const userId = `${userInfo?.accountName || ''}`;
        // @XW 2019.03.19 新增去重逻辑
        let selectedRowKeysTemp = [...tmpSelectedRowKeys];
        let selectedRecordsTemp = [...tmpSelectedRecords];
        if (printType === 'normal') {
            selectedRowKeysTemp = handleSelectedKeys(tmpSelectedRowKeys, config);
            selectedRecordsTemp = getSelectedRecords(tmpSelectedRecords, selectedRowKeysTemp, config);
        }
        // @XW 2019.03.22 新增对去重后如果没有单据要打印了直接返回不去下发打印任务
        if (selectedRowKeysTemp.length === 0) {
            deliveryTasksCallback({ success: true }, config);
            return;
        }
        console.log('printerList', printerList);
        const newConfig = {
            ...config,
            printerList,
        };
        let arrTasks = [];
        if (isBatch) {
            const task = transformBatchTaskInfo(selectedRecordsTemp, selectedRowKeysTemp, warehouseId, userId, newConfig);
            arrTasks.push(task);
        }
        else {
            arrTasks = selectedRecordsTemp.map((item) => {
                return transformTaskInfo(item, warehouseId, userId, newConfig);
            });
        }
        if (window.iBirdHybirdApi) {
            let printSocket = localStorage.getItem('printSocket');
            if (!printSocket) {
                localStorage.setItem('printSocket', socketType);
                printSocket = socketType;
            }
            if (printSocket === 'hybridapi') {
                window.iBirdHybirdApi.sendMessage('CallbackFunc', [
                    'print',
                    'sendTask',
                    JSON.stringify({ tasks: arrTasks }),
                ]);
            }
            else {
                execPrint(arrTasks);
                localStorage.setItem('selectedRowKeysStorage', '');
            }
        }
        else {
            // TODO
            // 在非智鸟容器下直接通过websocket通道进行打印处理
            execPrint(arrTasks);
            // 浏览器下面取消去重逻辑，否则过滤的单据处理失败无法再次勾选
            localStorage.setItem('selectedRowKeysStorage', '');
        }
    }, [config]);
    const handlePrint = useCallback(() => {
        const doPrint = () => {
            if (needConfig) {
                setSelectPrintVisible(true);
            }
            else {
                handlePrintSelected();
            }
            setLoading(true);
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        };
        const doQueryCheck = () => {
            if (queryParamCheck) {
                queryParamCheck(queryParams)
                    .then((msg) => {
                    if (msg) {
                        return CnMessage.warning(msg);
                    }
                    doPrint();
                })
                    .catch((e) => console.error(e));
            }
            else {
                doPrint();
            }
        };
        if (requestBeforePrint) {
            requestBeforePrint([setSelectedRecords, setSelectedRowKeys]).then(() => {
                doQueryCheck();
            });
        }
        else if (requestBeforePrint4L2) {
            const callback = requestBeforePrint4L2(selectedRecords);
            if (callback) {
                callback([setSelectedRecords, setSelectedRowKeys]).then(() => {
                    doQueryCheck();
                });
            }
            else {
                console.log('requestBeforePrint4L2====');
                doQueryCheck();
            }
        }
        else {
            doQueryCheck();
        }
    }, [
        requestBeforePrint,
        handlePrintSelected,
        queryParamCheck,
        needConfig,
        queryParams,
        printInstance,
    ]);
    const showTooltip = useMemo(() => {
        if (buttonConfig?.buttonHoverInfo?.needHover && (hoverInfo.content || hoverInfo.title)) {
            return true;
        }
        return false;
    }, [buttonConfig?.buttonHoverInfo?.needHover, hoverInfo.content, hoverInfo.title]);
    const printButton = useMemo(() => {
        return (<CnButton disabled={disabled} onClick={handlePrint} loading={loading} type="normal" data-hottag-name="cn-print-btn" {...btnProps} className={classnames('cn-print-btn', className || '')}>
        {children || name || $i18n.get({ id: '31255238681956352.CNTM', dm: '打印' })}
      </CnButton>);
    }, [btnProps, children, className, disabled, handlePrint, loading, name]);
    const menuItem = useMemo(() => {
        return (<div onClick={() => {
                if (!disabled) {
                    handlePrint();
                }
            }} data-hottag-name="cn-print-btn" {...btnProps} className={classnames('cn-print-btn menu-mode', className || '', {
                disabled,
                loading,
            })} style={{ flexGrow: 1 }}>
        {name || children || $i18n.get({ id: '31255238681956352.CNTM', dm: '打印' })}
      </div>);
    }, [btnProps, children, className, disabled, handlePrint, loading, name]);
    return (<>
      {isMenuItem ? (<>
          {showTooltip ? (<CnBalloon closable={false} title={hoverInfo.title} trigger={menuItem}>
              {hoverInfo.content}
            </CnBalloon>) : (menuItem)}
        </>) : (<>
          {showTooltip ? (<CnBalloon closable={false} title={hoverInfo.title} trigger={printButton}>
              {hoverInfo.content}
            </CnBalloon>) : (printButton)}
        </>)}

      {selectPrintVisible && (<SelectPrintDialog visible setVisible={setSelectPrintVisible} printerList={printerList} onOk={(printer) => {
                currentPrintRef.current = printer;
                handlePrintSelected();
            }}/>)}
    </>);
};
CnPrintBtn.displayName = 'CnPrintBtn';
export { CnPrintBtn };
